import React from 'react'
import type { ComponentProps, PartData } from '@enonic/react-components'

import HubspotFormPrototype from './prototype/HubspotForm'
import type { HubspotFormProps } from './prototype/HubspotForm/types'

export const HubspotForm = ({ data }: ComponentProps<PartData>) => {
	const { heading, region, portalId, formId, containerId } = (data || {}) as HubspotFormProps

	return (
		<HubspotFormPrototype
			heading={heading}
			region={region}
			portalId={portalId}
			formId={formId}
			containerId={containerId}
			isPart
		/>
	)
}
